import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ic-star-full_b7dd1e51fcf9fdf4a8a4ec7531489d82",
  "use": "ic-star-full_b7dd1e51fcf9fdf4a8a4ec7531489d82-usage",
  "viewBox": "0 0 28 27",
  "content": "<symbol viewBox=\"0 0 28 27\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"ic-star-full_b7dd1e51fcf9fdf4a8a4ec7531489d82\">\n<path d=\"M13.9993 21.028L22.2393 26.0013L20.0527 16.628L27.3327 10.3213L17.746 9.50797L13.9993 0.667969L10.2527 9.50797L0.666016 10.3213L7.94602 16.628L5.75935 26.0013L13.9993 21.028Z\" fill=\"#EB8D1C\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id